import { ApiService, type ApiRequestConfig } from "./api.service";
import type {
  TCurrentUserSessionPolicy,
  TWorkspaceSessionPolicy,
  TWorkspaceSessionPolicyUpdate,
} from "@/types/workspace";

export class WorkspaceSessionPolicyService extends ApiService {
  async getSessionPolicy(
    slug: string,
    config?: ApiRequestConfig,
  ): Promise<TWorkspaceSessionPolicy> {
    return this.get(`/api/workspaces/${slug}/session-policy/`, config);
  }

  /** The CALLER's enforced thresholds — needs no permission beyond
   * authentication, unlike the admin-gated workspace config above (NG-1955). */
  async getEffectiveSessionPolicy(config?: ApiRequestConfig): Promise<TCurrentUserSessionPolicy> {
    return this.get("/api/users/me/session-policy/", config);
  }

  async updateSessionPolicy(
    slug: string,
    data: TWorkspaceSessionPolicyUpdate,
  ): Promise<TWorkspaceSessionPolicy> {
    return this.patch(`/api/workspaces/${slug}/session-policy/`, data);
  }
}
